import enUS from "./locales/en-US.json";
import enGB from "./locales/en-GB.json";
import enIN from "./locales/en-IN.json";
import hi from "./locales/hi.json";
import te from "./locales/te.json";
import ur from "./locales/ur.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
export const SUPPORTED_LANGUAGES = [
    "en-US",
    "en-GB",
    "en-IN",
    "hi",
    "te",
    "ur",
    "ar",
    "fr",
];
export const SUPPORTED_NAMESPACES = [
    "appointment",
    "enquiry",
    "common",
    "validation",
    "errors",
    "portal",
];
export const DEFAULT_LANGUAGE = "en-US";
export const LANGUAGE_CONFIGS = [
    {
        code: "en-US",
        name: "American English",
        nativeName: "English (US)",
        region: "US",
        direction: "ltr",
    },
    {
        code: "en-GB",
        name: "British English",
        nativeName: "English (UK)",
        region: "GB",
        direction: "ltr",
    },
    {
        code: "en-IN",
        name: "Indian English",
        nativeName: "English (India)",
        region: "IN",
        direction: "ltr",
    },
    { code: "hi", name: "Hindi", nativeName: "हिन्दी", region: "IN", direction: "ltr" },
    { code: "te", name: "Telugu", nativeName: "తెలుగు", region: "IN", direction: "ltr" },
    { code: "ur", name: "Urdu", nativeName: "اردو", region: "PK", direction: "rtl" },
    { code: "ar", name: "Arabic", nativeName: "العربية", region: "AE", direction: "rtl" },
    {
        code: "fr",
        name: "French",
        nativeName: "Français",
        region: "CA",
        direction: "ltr",
    },
];
export function getLanguageDirection(code) {
    return (LANGUAGE_CONFIGS.find((lang) => lang.code === code)?.direction ?? "ltr");
}
function loadLanguageResources() {
    const resources = {};
    const languageFiles = {
        "en-US": enUS,
        "en-GB": enGB,
        "en-IN": enIN,
        hi: hi,
        te: te,
        ur: ur,
        ar: ar,
        fr: fr,
    };
    for (const [language, namespaces] of Object.entries(languageFiles)) {
        resources[language] = namespaces;
    }
    return resources;
}
export const i18nextConfig = {
    resources: loadLanguageResources(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: SUPPORTED_NAMESPACES,
    defaultNS: "common",
    detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
    },
    interpolation: {
        escapeValue: false,
    },
    debug: false,
    react: {
        useSuspense: false,
    },
};
export function getI18nextConfig() {
    return JSON.parse(JSON.stringify(i18nextConfig));
}
export function mergeI18nextConfig(consumerConfig) {
    const sdkConfig = getI18nextConfig();
    if (consumerConfig.resources) {
        for (const [language, namespaces] of Object.entries(consumerConfig.resources)) {
            if (!sdkConfig.resources) {
                sdkConfig.resources = {};
            }
            if (!sdkConfig.resources[language]) {
                sdkConfig.resources[language] = {};
            }
            sdkConfig.resources[language] = {
                ...sdkConfig.resources[language],
                ...namespaces,
            };
        }
    }
    if (consumerConfig.ns) {
        const consumerNs = Array.isArray(consumerConfig.ns)
            ? consumerConfig.ns
            : [consumerConfig.ns];
        const sdkNs = Array.isArray(sdkConfig.ns) ? sdkConfig.ns : [sdkConfig.ns];
        sdkConfig.ns = [...new Set([...sdkNs, ...consumerNs])];
    }
    if (consumerConfig.supportedLngs) {
        const consumerLngs = Array.isArray(consumerConfig.supportedLngs)
            ? consumerConfig.supportedLngs
            : [consumerConfig.supportedLngs];
        const sdkLngs = Array.isArray(sdkConfig.supportedLngs)
            ? sdkConfig.supportedLngs
            : [sdkConfig.supportedLngs];
        sdkConfig.supportedLngs = [...new Set([...sdkLngs, ...consumerLngs])];
    }
    return {
        ...sdkConfig,
        ...consumerConfig,
        resources: sdkConfig.resources,
        ns: sdkConfig.ns,
        supportedLngs: sdkConfig.supportedLngs,
    };
}
